<template>
  <div class="container">
    <div class="swiper-container-group">
      <div class="swiper-container" ref="mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide-basic swiper-slide">
            <div class="adjust-type">标准版</div>
            <div class="adjusts-money">￥<span class="adjust-money-number">4480</span>/年</div>
          </div>
          <div class="swiper-slide-higher swiper-slide">
            <div class="adjust-type">高级版</div>
            <div class="adjusts-money">￥<span class="adjust-money-number">5480</span>/年</div>
          </div>
          <div class="swiper-slide-flag swiper-slide">
            <div class="adjust-type">旗舰版</div>
            <div class="adjusts-money">￥<span class="adjust-money-number">7480</span>/年</div>
          </div>
           <!-- <div class="swiper-slide-chain swiper-slide">
            <div class="adjust-type">连锁版</div>
            <div class="adjusts-money">价格详情请咨询专属运营顾问</div>
          </div> -->
        </div>
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
      <div class="back-white"></div>
    </div>
    <div class="adjust-service-group">
      <div :class="`${isExpanded ? '' : 'notExpand'}`">
      <div class="card-content">{{content}}</div>
      <div class="basic-function">
        <div class="adjust-service-title basic-function">
          <img :src="left" />
          <span>基础功能</span>
          <img :src="right" />
        </div>
        <div class="adjust-service-content">
          <div
            class="adjust-service-content-item"
            v-for="(item,index) in basicFunction"
            :key="index"
          >
            <span>{{item.content}}</span>
            <img :src="choose" alt />
          </div>
        </div>
      </div>

      <div class="study-inline">
        <div class="adjust-service-title study-inline">
          <img :src="left" />
          <span>在线教学</span>
          <img :src="right" />
        </div>
        <div class="adjust-service-content">
          <div class="adjust-service-content-item" v-for="(item,index) in studyInline" :key="index">
            <span :class="flag || chain?null:'null'">{{item.content}}</span>
            <img v-if="flag && item.show" :src="choose" alt />
            <img v-if="chain && item.show" :src="choose" alt />
            <span v-if="flag && !item.show">{{item.text}}</span>
             <span v-if="chain && !item.show">{{item.text}}</span>
          </div>
        </div>
      </div>

      <div class="branch-casting">
        <div class="adjust-service-title branch-tasting">
          <img :src="left" />
          <span>品牌铸造</span>
          <img :src="right" />
        </div>


       <div v-if="chain">
          <div class="adjust-service-content">
          <div
            class="adjust-service-content-item"
            v-for="(item,index) in branchTastingvip"
            :key="index"
          >
            <span :class="basic?'null':null">{{item.content}}</span>
            <img v-if="!basic" :src="choose" alt />
          </div>
        </div>
        </div>
        <div v-else>
        <div class="adjust-service-content">
          <div
            class="adjust-service-content-item"
            v-for="(item,index) in branchTasting"
            :key="index"
          >
            <span :class="basic?'null':null">{{item.content}}</span>
            <img v-if="!basic" :src="choose" alt />
          </div>
        </div>
        </div>

        <div class="adjust-service-contents">
          <div
            class="adjust-service-content-item"
            v-for="(item,index) in branchTastings"
            :key="index"
          >
           <span :class="chain ?null:'null'">{{item.content}}</span>
            <img v-if="chain" :src="choose" alt />
          </div>
        </div>
      </div>


     <div class="study-inline">
        <div class="adjust-service-title study-inline">
          <img :src="left" />
          <span>总校运营中台</span>
          <img :src="right" />
        </div>
        <div class="adjust-service-content">
          <div class="adjust-service-content-item" v-for="(item,index) in SchoolOperation" :key="index">
            <span :class="chain ?null:'null'">{{item.content}}</span>
            <img v-if="chain && item.show" :src="choose" alt />
          </div>
        </div>
      </div>
      <div class="add-value">
        <div class="adjust-service-title study-inline">
          <img :src="left" />
          <span>增值模块</span>
          <img :src="right" />
        </div>
        <div class="adjust-service-content">
          <div
            class="adjust-service-content-item"
            v-for="(item,index) in addValueFlags"
            :key="index"
          >
           <span :class="chain ||flag ?null:'null'">{{item.content}}</span>
            <img v-if="chain || flag" :src="choose" alt />
          </div>
        </div>
         <div class="adjust-service-contents">
          <div
            class="adjust-service-content-item"
            v-for="(item,index) in addValueFlagCash"
            :key="index"
          >
           <span>{{item.content}}</span>
            <img :src="choose" alt />
          </div>
        </div>
        <div v-if="flag||chain">
          <div class="adjust-service-content">
            <div class="adjust-service-content-item" v-for="(item,index) in addValueFlag" :key="index">
              <span>{{item.content}}</span>
              <img class="tips-img" v-if="item.icon" :src="item.icon" @click="onClickBtn(item.content)">
              <div class="tips-content" v-if="item.icon">
                <div class="tips-content-item">购买/使用麦麦打卡，需提前将小麦助教免费升级至5.0系统。如需升级请联系工作人员。</div>
                <div class="tips-content-bottom"></div>
              </div>
              <div class="tips-content-maimeng" v-if="item.icon">
                <div class="tips-content-item">购买/使用麦萌海报，需提前将小麦助教免费升级至5.0系统。如需升级请联系工作人员。</div>
                <div class="tips-content-bottom"></div>
              </div>
              <img v-if="flag && item.show" :src="choose" alt />
              <img v-if="chain && item.show" :src="choose" alt />
              <span v-if="flag && item.text">{{item.text}}</span>
              <span v-if="chain && item.text">{{item.text}}</span>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="adjust-service-content">
            <div class="adjust-service-content-item" v-for="(item,index) in addValueNoFlag" :key="index">
              <span :class="item.text?null:'null'">{{item.content}}</span>
              <img class="tips-img" v-if="item.icon" :src="item.icon" @click="onClickBtn(item.content)">
              <div class="tips-content" v-if="item.icon">
                <div class="tips-content-item">购买/使用麦麦打卡，需提前将小麦助教免费升级至5.0系统。如需升级请联系工作人员。</div>
                <div class="tips-content-bottom"></div>
              </div>
              <div class="tips-content-maimeng" v-if="item.icon">
                <div class="tips-content-item">购买/使用麦萌海报，需提前将小麦助教免费升级至5.0系统。如需升级请联系工作人员。</div>
                <div class="tips-content-bottom"></div>
              </div>
              <img v-if="item.show" :src="choose" alt />
              <span v-if="item.text">{{item.text}}</span>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="expand-wrap">
        <div v-if="!isExpanded" class="expand" @click="clickExpand">展开 <img :src="downIcon" alt=""></div>
        <div v-else class="expand" @click="clickExpand">收起 <img :src="upIcon" alt=""></div>
      </div>
      <div class="footer">
        <img src="https://image.xiaomaiketang.com/xm/internal/52b4R7N85G.png" alt=""/>
      </div>
    </div>
  </div>
</template>
<script>
import RenewPayService from "@/service/RenewPayService";
const basicIcon = "https://image.xiaomaiketang.com/xm/7iGnzQRsaM.png";
const higherIcon = "https://image.xiaomaiketang.com/xm/WKeQpXNxM4.png";
const flagIcon = "https://image.xiaomaiketang.com/xm/KdF6H6ba8H.png";
const chainIcon = "https://image.xiaomaiketang.com/xm/3mZwaCD2kt.png";

export default {
  name: 'oldPackage',
  props: ['versionType'],
  data() {
    return {
      isExpanded: false, // 是否展开
      downIcon: 'https://image.xiaomaiketang.com/xm/internal/Y7saA4WSY7.png',
      upIcon: 'https://image.xiaomaiketang.com/xm/internal/pyH22tENAY.png',
      initialSlide: 0,
      left: "https://image.xiaomaiketang.com/xm/Xe38ktyQkb.png",
      right: "https://image.xiaomaiketang.com/xm/ZhPsZQWiYM.png",
      choose: basicIcon,
      xmversion: null,
      basic: true,
      higher: false,
      flag: false,
      chain:false,
      content:'满足教务管理、家校互动、营销推广、财务管理等基础需求，快速提升机构运营管理效率。',
      basicContent:'满足教务管理、家校互动、营销推广、财务管理等基础需求，快速提升机构运营管理效率。',
      higherContent:'贯彻线下机构核心教育环节，搭配专属机构微官网、公众号，快速铸造机构专属品牌。',
      flagContent:"打通线上线下全场景，搭配线上教学工具，构建一站式教育信息化综合解决方案，深度满足机构的经营需求，有效提升机构市场竞争力。",
      chainContent:"连锁品牌全场景数字化解决方案，为连锁品牌搭建“数据+营销”的总部运营中台，提升多校区经营管理效率，形成统一的品牌矩阵。",
      // 基础功能结构
      basicFunction: [
        {
          content: "招生营销",
          show: true,
        },
        {
          content: "教务管理",
          show: true,
        },
        {
          content: "家校互动",
          show: true,
        },
        {
          content: "财务管理",
          show: true,
        },
        {
          content: "数据管理",
          show: true,
        },
      ],
      // 品牌铸造结构
      branchTasting: [
        {
          content: "专属微官网",
          show: true,
          class: true,
        },
        {
          content: "专属微信号",
          show: true,
        },
      ],
        branchTastingvip: [
        {
          content: "自主品牌微官网",
          show: true,
          class: true,
        },
        {
          content: "专属微信号",
          show: true,
        },
      ],
      branchTastings: [
        {
          content: "自定义B端装修",
          show: true,
        },
        {
          content: "自定义家长端装修",
          show: true,
        },
        {
          content: "专属域名",
          show: true,
        },
      ],
      // 总校运营中台
      SchoolOperation: [
        {
          content: "多级组织架构管理",
          show: true,
        },
        {
          content: "加盟商/代理商管理",
          show: true,
        },
        {
          content: "数据面板",
          show: true,
        },
        {
          content: "跨校区教务管理",
          show: true,
        },
      ],
      // 线上学习结构
      studyInline: [
        {
          content: "互动班课",
          show: false,
          text:'按需充值'
        },
        {
          content: "大班直播",
          show: true,
        },
        {
          content: "视频课",
          show: true,
        },
        {
          content: "资料云盘",
          show: true,
        },
      ],
      // 增值服务结构（4.0展示提示）
      addValueFlags: [
        {
          content: "会员宝",
          show: true,
        },
        {
          content: "人脸考勤",
          show: true,
        },
      ],
      addValueFlagCash: [
        {
          content: "小麦收银",
          show: true,
        }
      ],
      addValueFlag: [
        {
          content: "麦麦打卡",
          show: true,
          icon: null,
        },
        {
          content: "麦萌海报",
          show: true,
          icon: null,
        },
        {
          content: 'AI招生',
          show: false,
          text: '188元/年',
          icon: null
        },
        {
          content: "小麦学院会员",
          show: true,
        },
        {
          content: "短信",
          show: false,
          text: "按需充值",
        },
        {
          content: "呼叫中心",
          show: false,
          text: "按需开通",
        },
      ],
      // 增值服务结构（5.0不展示提示）
      addValueNoFlag: [
        {
          content: "麦麦打卡",
          show: false,
          text:'1680元/年',
          icon: null,
        },
        {
          content: "麦萌海报",
          show: false,
          text:'1499元/年',
          icon: null,
        },
        {
          content: 'AI招生',
          show: false,
          text: '188元/年',
          icon: null
        },
        {
          content: "小麦学院会员",
          show: false,
          text:'999元/年'
        },
        {
          content: "短信",
          show: false,
          text: "按需充值",
        },
        {
          content: "呼叫中心",
          show: false,
          text: "按需开通",
        },
      ],
    };
  },
  methods: {
    init() {
      const _this = this;
      var swiper = new Swiper('.swiper-container', {
        slidesPerView: 1.16,
        spaceBetween: 8,
        centeredSlides: true,
        initialSlide: _this.initialSlide,
        on:{
          // 动画结束后更改对应的数据
          slideChangeTransitionEnd: function() {
            const index = this.activeIndex;

            if(index === 0){
              _this.basic = true;
              _this.higher = false;
              _this.flag = false;
              _this.chain=false;
              _this.content = _this.basicContent;
              _this.choose = basicIcon;
            }
            if(index === 1){
              _this.basic = false;
              _this.higher = true;
              _this.flag = false;
              _this.chain = false;
              _this.content = _this.higherContent;
              _this.choose = higherIcon;
            }
            if(index === 2){
              _this.basic = false;
              _this.higher = false;
              _this.flag = true;
              _this.chain = false;
              _this.content = _this.flagContent;
              _this.choose = flagIcon;
            }
             if(index === 3){
              _this.basic = false;
              _this.higher = false;
              _this.flag = false;
              _this.chain = true;
              _this.content = _this.chainContent;
              _this.choose = chainIcon;
            }
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    },
    // 通过URL获取当前版本
    parseUrl() {
      let No;

      this.xmversion = window.location.hash.match(/xmversion=(\d\.\d)/)[1];
      /**
       * 3，4，5分别对应标准版，高级版，旗舰版
       */
      try {
        No = window.saasBasicTypeEnum(this.versionType);
      } catch (error) {
        No = 3;
      }
     
      this.initialSlide = ['', '', '', 0, 1, 2, 3][parseInt(No)];
      console.log('initialSlide',this.initialSlide)
    },
    // 点击icon提示
    onClickBtn(es){
      if(es==="麦麦打卡"){
        let showTips = document.querySelector('.tips-content');
        if(showTips.style.display === 'block'){
          showTips.style.display = 'none';
        }else{
          showTips.style.display = 'block';
        }
      }
      if(es==="麦萌海报"){
        let showTips = document.querySelector('.tips-content-maimeng');
        if(showTips.style.display === 'block'){
          showTips.style.display = 'none';
        }else{
          showTips.style.display = 'block';
        }
      }
    },

    clickExpand() {
      this.isExpanded = !this.isExpanded
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  watch:{
    versionType(newValue){
      if(newValue){
         this.parseUrl();
         this.init();
      }
    }
  },
  // 判断机构是4.0还是5.0
  created(){
    if(this.xmversion && this.xmversion==='4.0'){
      this.addValueFlag[0].icon = 'https://image.xiaomaiketang.com/xm/bmPr4b7sPY.png'
      this.addValueNoFlag[0].icon = 'https://image.xiaomaiketang.com/xm/bmPr4b7sPY.png'
      this.addValueFlag[1].icon = 'https://image.xiaomaiketang.com/xm/bmPr4b7sPY.png'
      this.addValueNoFlag[1].icon = 'https://image.xiaomaiketang.com/xm/bmPr4b7sPY.png'
    }
  },
};
</script>

<style lang="less">
.container {
  height: 100vh;
  overflow: scroll;
  font-family: PingFangSC-Regular, PingFang SC;
  background: #ffffff;

  .expand-wrap {
    text-align: center;
    margin-top: 0.32rem;
    .expand {
      display: inline-block;
      font-size: 0.28rem;
      line-height: 0.4rem;
      color: #666;

      img {
        width: 0.28rem;
        line-height: 0.4rem;
        vertical-align: -0.04rem;
      }
    }
  }

  .footer {
    width: 100%;
    margin-top: 0.5rem;
    img {
      width: 100%;
    }
  }
  .swiper-container-group{
    width: 100vw;
    height: 198px;
    padding-top: 34px;
    background: #fff3e1;
  }
  .back-white{
    width: 0;
    height: 0;
    border-top: 36px solid transparent;
    border-left: 50vw solid #ffffff;
    border-right: 50vw solid #ffffff;
    // border: 10px solid red;
    position: relative;
    top: -36px;
    z-index: 999;
  }
  .swiper-slide-basic{
    background-image: url('https://image.xiaomaiketang.com/xm/shBErC87J7.png');
    background-size: 100% 100%;
    color: #ffffff;
  }
  .swiper-slide-higher{
    background-image: url('https://image.xiaomaiketang.com/xm/ifsCDbrYX4.png');
    background-size: 100% 100%;
    color: #333333;
  }
  .swiper-slide-flag{
    height: 100%;
    overflow: auto;
    background-image: url('https://image.xiaomaiketang.com/xm/P38MBG8tSx.png');
    background-size: 100% 100%;
    color: #FFDBA8;
  }
   .swiper-slide-chain{
    height: 100%;
    overflow: auto;
    background-image: url('https://image.xiaomaiketang.com/xm/XcHnDhrhHH.png');
    background-size: 100% 100%;
    color: #F7DC86;
  }

  .swiper-container{
    height: 195px;
    width: 100vw;
    .swiper-pagination-bullet {
      width: 5px;
      height: 5px;
      &.swiper-pagination-bullet-active {
        background: #fff;
      }
    }
    img{
      width: 100%;
      height: 100%;
    }
    .adjust-type{
      width:57px;
      height:21px;
      margin: auto;
      margin-top: 29px;
      font-size:19px;
      font-weight: bold;
      line-height:21px;
    }
    .adjust-money{
      width:250px;
      height:21px;
      font-size:17px;
      margin:auto;
      margin-top: 22px;
      font-weight:500;
      line-height:21px;
    }
    .adjust-money-number{
      font-size: 35px;
      font-weight: bold;
    }
    .adjusts-money{
      width:250px;
      height:21px;
      font-size:17px;
      margin:auto;
      margin-top: 42px;
      font-weight:500;
      line-height:21px;
    }
  }
  .adjust-service-group {
    height: calc(~"100vh - 160px"); /* 计算除了轮播图的其他内容的高度 */

    .notExpand {
      position: relative;
      height: 6.54rem;
      overflow: hidden;

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 0;
        width: 327px;
        height: 1.5rem;
        margin-left: -163px;
        border-radius: 5px;
        background-image: linear-gradient(rgba(250,250,250,0.7), rgba(250,250,250,1));
      }
    }
    .card-content {
      text-align: center;
      width: 328px;
      height: 36px;
      margin: auto;
      font-size: 13px;
      font-weight: 400;
      color: #999999;
      line-height: 18px;
      padding: 55px 15px 30px 15px;
      background: #ffffff;
    }
    .adjust-service-title {
      &.basic-function {
        margin-bottom: 13px;
      }
      &.branch-tasting,
      &.study-inline,
      &.add-value {
        margin-bottom: 8px;
      }
      span {
        font-size: 15px;
        font-weight: 500;
        color: #333333;
        line-height: 21px;
        margin: 0 8px;
        vertical-align: middle;
      }
      img {
        width: 12px;
        height: 8px;
      }
    }
    .adjust-service-contents {
      width: 327px;
      margin: auto;
      // padding: 8px 20px;
      border-radius: 5px;
      background-color: #fafafa;
      .adjust-service-content-item {
        width: 275px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        span {
          font-size: 15px;
          font-weight: 400;
          color: #666666;
          line-height: 21px;
        }
        img {
          width: 15px;
          height: 15px;
        }
        .tips-img{
          width: 14px;
          height: 14px;
          position: absolute;
          left: 64px;
        }
        .tips-content{
          display: none;
          position: absolute;
          width:200px;
          height:75px;
          border-radius: 10px;
          background:rgba(0,0,0,0.7);
          padding: 10px 12px 15px;
          position: absolute;
          left: 53px;
          top: -80px;
          .tips-content-item{
            font-size:13px;
            font-weight:400;
            color:#ffffff;
            line-height:18px;
            text-align: left;
          }
          .tips-content-bottom{
            width: 0;
            height: 0;
            border-width: 6px;
            border-style: solid;
            border-color: rgba(0,0,0,0.7) transparent transparent transparent;
            position: relative;
            top: 11px;
          }
        }
        .tips-content-maimeng{
          display: none;
          position: absolute;
          width:200px;
          height:75px;
          border-radius: 10px;
          background:rgba(0,0,0,0.7);
          padding: 10px 12px 15px;
          position: absolute;
          left: 53px;
          top: -38px;
          .tips-content-item{
            font-size:13px;
            font-weight:400;
            color:#ffffff;
            line-height:18px;
            text-align: left;
          }
          .tips-content-bottom{
            width: 0;
            height: 0;
            border-width: 6px;
            border-style: solid;
            border-color: rgba(0,0,0,0.7) transparent transparent transparent;
            position: relative;
            top: 11px;
          }
        }
      }
      .adjust-service-content-item:not(:last-child) {
        margin-bottom: 20px;
      }
    }
    .adjust-service-content {
      width: 327px;
      margin: auto;
      padding: 16px 20px;
      border-radius: 5px;
      background-color: #fafafa;
      .adjust-service-content-item {
        width: 275px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        span {
          font-size: 15px;
          font-weight: 400;
          color: #666666;
          line-height: 21px;
        }
        img {
          width: 15px;
          height: 15px;
        }
        .tips-img{
          width: 14px;
          height: 14px;
          position: absolute;
          left: 64px;
        }
        .tips-content{
          display: none;
          position: absolute;
          width:200px;
          height:75px;
          border-radius: 10px;
          background:rgba(0,0,0,0.7);
          padding: 10px 12px 15px;
          position: absolute;
          left: 53px;
          top: -80px;
          .tips-content-item{
            font-size:13px;
            font-weight:400;
            color:#ffffff;
            line-height:18px;
            text-align: left;
          }
          .tips-content-bottom{
            width: 0;
            height: 0;
            border-width: 6px;
            border-style: solid;
            border-color: rgba(0,0,0,0.7) transparent transparent transparent;
            position: relative;
            top: 11px;
          }
        }
        .tips-content-maimeng{
          display: none;
          position: absolute;
          width:200px;
          height:75px;
          border-radius: 10px;
          background:rgba(0,0,0,0.7);
          padding: 10px 12px 15px;
          position: absolute;
          left: 53px;
          top: -38px;
          .tips-content-item{
            font-size:13px;
            font-weight:400;
            color:#ffffff;
            line-height:18px;
            text-align: left;
          }
          .tips-content-bottom{
            width: 0;
            height: 0;
            border-width: 6px;
            border-style: solid;
            border-color: rgba(0,0,0,0.7) transparent transparent transparent;
            position: relative;
            top: 11px;
          }
        }
      }
      .adjust-service-content-item:not(:last-child) {
        margin-bottom: 20px;
      }
    }
    .adjust-service-bottom {
      width: 182px;
      margin: 16px auto 0;
      padding-bottom: 24px;
      span {
        font-size: 13px;
        font-weight: 400;
        color: #999999;
        line-height: 18px;
      }
    }
    .basic-function {
      margin-top: 30px;
    }
    .branch-casting,
    .study-inline,
    .add-value {
      margin-top: 24px;
    }
  }
  .null{
    color: #cccccc !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/module/renew/oldPackage.vue